import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import View from '@loggi/ui/components/view';
import Spinner from '@loggi/ui/components/spinner';
import styles from './index.scss';

function LoaderMask({ absolute, spinnerProps }) {
  const className = classNames(styles.mask, {
    [styles.maskAbsolute]: absolute
  });

  return (
    <View className={className}>
      <Spinner className={styles.spinner} {...spinnerProps} />
    </View>
  );
}

LoaderMask.propTypes = {
  absolute: PropTypes.bool,
  spinnerProps: PropTypes.shape(Spinner.propTypes)
};

LoaderMask.defaultProps = {
  absolute: true,
  spinnerProps: {
    size: 50,
    strokeWidth: 3
  }
};

LoaderMask.displayName = 'LoaderMask';
export default LoaderMask;
